import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Select,
  FormLabel,
  FormControl,
  useToast,
} from "@chakra-ui/react";
import { ehcExpert } from "../../Config/ehcExpert";
import { convertTime, convertToUTC, updateData } from "../../Config/functions";
import AssessmentDataService from "../../services/Assessment";
import { expertsArray } from "../../Config/experts";

export const DiscoveryModal = ({ isOpen, onClose , row , func }: any) => {
  const  token = localStorage.getItem("logged_in_user_token");
  const toast = useToast();

  const [state, setState] = useState("");

  const sendExpertDiscoveryMessage = (expert: any) => {
    let template: string = "good_news_march_hg";
    const dates = convertToUTC(
      `${row.data.date} ${convertTime(row.data.time)}`
    );
    const issues = row.data.screening_information.issues;
    const issueString = issues.join(", ");
    const clientData: any = [
      {
        phone_number: "91" + expert.mobile,
        name: expert.name,
        dynamic_data: {
          key1: row.data.client_information.name,
          key2: row.data.client_information.email,
          key3: row.data.client_information.phone,
          key4: issueString,
          key5: `${row.data.date} T ${convertTime(row.data.time)}`,
          key6: `https://www.google.com/calendar/render?action=TEMPLATE&text=Emotional%20Health%20Consultation%20%7C%20ManoShala&details=&location=Phone%20Call&dates=${dates[0]}%2F${dates[1]}&ctz=Asia%2FKolkata`,
        },
      },
    ];
    const data: any = updateData(
      row,
      expert.expertId,
      "EHC Call Details",
      "UPCOMING",
      "emotional_health"
    );
    const templateName = template;
    AssessmentDataService.sendMessage({
      templateName: templateName,
      clientdata: clientData,
    },token)
      .then((res) => {
        AssessmentDataService.update(data, row.id,token)
          .then((response: any) => {
            func("DISCOVERY_FOLLOWUP");
            toast({
              position: "top",
              title: "Message Sent Successfull.",
              status: "success",
              duration: 1000,
              isClosable: true,
            });
            onClose();
          })
          .catch((e: Error) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

 const sendDiscoveryMessage = () => {

    let template: string = "emotional_health";
    const dates = convertToUTC(`${row.data.date} ${convertTime(row.data.time)}`)
    const expert: any | undefined = expertsArray.find((el:any) => el.expertId == state) || { expertId: "", name: state ? state.split("_")[1].toUpperCase() : "", position: "", link: "https://www.manoshala.com/sessions", mobile: "" };
    const clientData: any = [{
      phone_number:"91" + row.data.client_information.phone,
      name: row.data.client_information.name,
      dynamic_data: {
        key1: row.data.date,
        key2: convertTime(row.data.time),
        key3: `${expert.name} | ${expert.position} ${expert.link}`,
        key4: `https://www.google.com/calendar/render?action=TEMPLATE&text=Emotional%20Health%20Consultation%20%7C%20ManoShala&details=&location=Phone%20Call&dates=${dates[0]}%2F${dates[1]}&ctz=Asia%2FKolkata`,
      }
    }
    ];
    const sendData = { templateName: template, clientdata: clientData };
    if(state === ""){
      toast({
        position: "top",
        title: "Message Failed.",
        description: "Expert is not selected",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
    else if (!row.data.date || !row.data.time ){
      toast({
        position: "top",
        title: "Message Failed.",
        description: "Invalid Date or Time",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
    else if (!row.data.screening_information.issues ||row.data.screening_information.issues.length==0){
      toast({
        position: "top",
        title: "Message Failed.",
        description: "Invalid Issues",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
   else{
     AssessmentDataService.sendMessage(sendData,token).then((res) => {
      sendExpertDiscoveryMessage( expert)
    }).catch((e) => {
      console.log(e);
    })
  }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send EHC Call Details Message</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Select Message</FormLabel>
            <Select onChange={(e: any) => setState(e.target.value)}>
              {ehcExpert.map((el: any) => (
                <option value={el.value}>{el.name}</option>
              ))}
            </Select>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button  bgColor='#327171' color={"white"} mr={3} onClick={sendDiscoveryMessage} >
            Send message
          </Button>
          <Button  bgColor='red' color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
